module.exports = __webpack_public_path__ + "img/FOU.f7d824ca.svg";